import React from 'react';
import { Link } from 'react-router-dom';
import Reveal from '../Reveal/Reveal';
import ofgemImage from '../../assets/images/compliance-ofgem.jpg';
import euImage from '../../assets/images/compliance-eu.jpg';
import carbonImage from '../../assets/images/compliance-carbon.jpg';
import { IconArrowRight } from '../Icons/Icons';
import '../../assets/css/compliance-teaser.css';

const PILLARS = [
  {
    id: 'ofgem',
    index: '01',
    eyebrow: 'Regulatory Compliance',
    title: 'Ofgem & Regulatory Compliance',
    image: ofgemImage,
    alt: 'Electricity transmission tower on a grass field',
    text: 'End-to-end Ofgem support, from pre-accreditation through to ongoing compliance and audit preparation.',
  },
  {
    id: 'eu-red',
    index: '02',
    eyebrow: 'International Certification',
    title: 'EU Renewable Energy Directive',
    image: euImage,
    alt: 'European Union flag flying',
    text: 'ISCC EU certification, GHG calculations, and DENA and Nabisy administration handled for you.',
  },
  {
    id: 'carbon',
    index: '03',
    eyebrow: 'Carbon & ESG Reporting',
    title: 'Sustainability & Carbon Reporting',
    image: carbonImage,
    alt: 'Sustainability and carbon reporting dashboard on a laptop',
    text: 'Audit-ready GHG calculations and carbon reporting that stands up to regulatory scrutiny.',
  },
];

function ComplianceTeaser() {
  return (
    <section className="section section-white" id="compliance">
      <div className="container">
        <div className="section-header">
          <Reveal direction="up">
            <span className="section-label">Detailed Consultancy Services</span>
            <h2 className="section-title">Compliance, Certification &amp; Reporting</h2>
            <p className="section-subtitle">
              In-depth support across the three pillars of regulatory and sustainability compliance
              for renewable energy businesses.
            </p>
          </Reveal>
        </div>

        <div className="hct-grid">
          {PILLARS.map((pillar, index) => (
            <Reveal direction="up" delay={index * 90} key={pillar.id}>
              <article className="hct-card card">
                <div className="hct-media">
                  <img src={pillar.image} alt={pillar.alt} />
                  <span className="hct-index">{pillar.index}</span>
                </div>
                <div className="hct-body">
                  <span className="hct-eyebrow">{pillar.eyebrow}</span>
                  <h3 className="hct-title">{pillar.title}</h3>
                  <p className="hct-text">{pillar.text}</p>
                  <Link to={`/compliance#${pillar.id}`} className="hct-link">
                    Learn more
                    <IconArrowRight width={16} height={16} />
                  </Link>
                </div>
              </article>
            </Reveal>
          ))}
        </div>

        <Reveal direction="up">
          <div className="hct-footer">
            <Link to="/compliance" className="btn btn-primary">
              View all compliance services
              <IconArrowRight width={17} height={17} />
            </Link>
          </div>
        </Reveal>
      </div>
    </section>
  );
}

export default ComplianceTeaser;
